import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import { attrConditionalDisplayColObj, getColDefaultValue } from "components/PimDashboard/data";
import { attrValAssocObj } from "components/PimDashboard/DashboardComponents/Designer/DesignerAttributes/data";
import { PimDashboardState } from "context/PimDashboardContext";
import { useEffect, useState } from "react";
import { removeDropdownOptionsBasedonDependency } from "../RenderAttributes/RenderAttributeInputs";
import RenderStyleInputField from "../RenderStyleInputFieldNU/RenderStyleInputField";

const RenderConditionalAttributeInputs = ({ columns, setData, data, width, attrGrp, setErrorObj, errorObj, itemWidth = "24%" }) => {
	const { allAttributes } = PimDashboardState();
	const condGrpAttrColkey = attrGrp?.data?.[attrConditionalDisplayColObj.key];
	let colCondAttr = null;
	if (condGrpAttrColkey && allAttributes) {
		let arr = allAttributes.filter((row) => row?.key === condGrpAttrColkey);
		if (arr?.length) colCondAttr = arr[0];
	}
	useEffect(() => {
		if (colCondAttr) {
			let condAttrColVal = data?.[colCondAttr?.linked_table]?.[condGrpAttrColkey]
				? data?.[colCondAttr?.linked_table]?.[condGrpAttrColkey]
				: "";

			if (condAttrColVal !== currentConditionalAttr) {
				if (condAttrColVal !== getColDefaultValue(colCondAttr)) {
					let a1 = [],
						a2 = [];
					const currentCondValue = data?.[colCondAttr.linked_table]?.[colCondAttr.key];
					columns?.forEach((col) => {
						const attrDisplayTrigger = col?.data?.[attrConditionalDisplayColObj.key];
						const hasDisplayTrigger = Array.isArray(attrDisplayTrigger) && attrDisplayTrigger.length > 0;

						if (!hasDisplayTrigger || attrDisplayTrigger.includes(currentCondValue)) {
							a1.push(col);
						} else {
							a2.push(col);
						}
					});
					setCurrentConditionalAttr(condAttrColVal);
					setArr1(a1);
					setArr2(a2);
				} else {
					setArr1(columns);
					setArr2([]);
				}
			}
		} else {
			setArr1(columns);
			setArr2([]);
		}
	}, [data]);
	const [arr1, setArr1] = useState([]);
	const [arr2, setArr2] = useState([]);
	const [viewAll, setViewAll] = useState(false);
	const [currentConditionalAttr, setCurrentConditionalAttr] = useState();
	return (
		<Box width="100%">
			<Box display="flex" width={width ? width : "100%"} flexWrap="wrap" p={1} alignItems="flex-start" columnGap="1%" rowGap="2px">
				{arr1?.map((column) => {
					let options = removeDropdownOptionsBasedonDependency(column, data, column?.[attrValAssocObj], allAttributes);
					return (
						<RenderStyleInputField
							column={{ ...column, [attrValAssocObj]: options }}
							data={data}
							setData={setData}
							selectOptObjName={attrValAssocObj}
							width={itemWidth}
							longWidth={"48%"}
							attrGrp={attrGrp}
							error={!!errorObj?.[column.key]}
							errorObj={errorObj}
							setError={setErrorObj}
						/>
					);
				})}
			</Box>
			<Box display="flex" justifySelf="end">
				<Button
					sx={{ marginLeft: "auto" }}
					onClick={() => setViewAll(!viewAll)}
					endIcon={viewAll ? <ExpandLess fontSize="large" /> : <ExpandMore fontSize="large" />}>
					View {viewAll ? "Less" : "All"}
				</Button>
			</Box>
			<Box display={viewAll && arr2?.length ? "flex" : "none"} width={width ? width : "100%"} flexWrap="wrap" p={1} alignItems="flex-start" columnGap="1%" rowGap="2px">
				{arr2?.map((column) => {
					let options = removeDropdownOptionsBasedonDependency(column, data, column?.[attrValAssocObj], allAttributes);
					return (
						<RenderStyleInputField
							column={{ ...column, [attrValAssocObj]: options }}
							data={data}
							setData={setData}
							selectOptObjName={attrValAssocObj}
							width={itemWidth}
							longWidth={"48%"}
							attrGrp={attrGrp}
							error={!!errorObj?.[column.key]}
							errorObj={errorObj}
							setError={setErrorObj}
						/>
					);
				})}
			</Box>
		</Box>
	);
};

export default RenderConditionalAttributeInputs;
